export default __webpack_public_path__ + "static/1294-78c56289e9f6ac8e237401a155ee6c91.gif";